'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redux = require('redux');

var _arrayAsObj = require('shared/utils/arrayAsObj');

var _arrayAsObj2 = _interopRequireDefault(_arrayAsObj);

var _getOrganizedJobs2 = require('./utils/getOrganizedJobs');

var _getOrganizedJobs3 = _interopRequireDefault(_getOrganizedJobs2);

var _getTitleForLevel = require('shared/utils/getTitleForLevel');

var _getTitleForLevel2 = _interopRequireDefault(_getTitleForLevel);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getJobFromRoute = function getJobFromRoute(route, jobs) {
  var slug = route.split('/').pop();
  return (0, _extends3.default)({}, jobs[slug], {
    isActive: true,
    slug: slug
  });
};

//import objAsArray from 'shared/utils/objAsArray';


var getIsSameSubsector = function getIsSameSubsector(fromJob, toJob) {
  return fromJob.subsector === toJob.subsector;
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var user = _ref.user,
      _ref$data = _ref.data,
      jobs = _ref$data.jobs,
      subsectors = _ref$data.subsectors,
      skills = _ref$data.skills,
      interests = _ref$data.interests,
      educationLevels = _ref$data.educationLevels,
      positions = _ref.ui.jobCareerMap.positions;
  var route = _ref2.route;

  var jobsWithMatch = (0, _arrayAsObj2.default)((0, _getAllMatchingJobs2.default)({
    user: user,
    data: {
      jobs: jobs,
      skills: skills,
      interests: interests,
      educationLevels: educationLevels
    }
  }).map(function (j) {
    return (0, _extends3.default)({}, j, {
      subsector: (subsectors[j.subsectors[0]] || {}).slug || '',
      match: j.matches.match,
      description: j.shortDesc
    });
  }));

  var job = getJobFromRoute(route, jobsWithMatch);

  var _getOrganizedJobs = (0, _getOrganizedJobs3.default)(jobsWithMatch, job),
      levels = _getOrganizedJobs.levels,
      connections = _getOrganizedJobs.connections;

  return {
    positions: positions,
    connections: connections.map(function (conn) {
      var fromJob = jobsWithMatch[conn.from.slug];
      var toJob = jobsWithMatch[conn.to.slug];
      var isSameSubsector = getIsSameSubsector(fromJob, toJob);

      return (0, _extends3.default)({}, conn, {
        isSameSubsector: isSameSubsector
      });
    }),
    levels: (0, _keys2.default)(levels).map(function (level) {
      return (0, _extends3.default)({
        level: level
      }, (0, _getTitleForLevel2.default)(level), {
        data: levels[level].columns
      });
    })
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPosition: (0, _redux.bindActionCreators)(_actions.getPosition, dispatch)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/selectors.js
// module id = 1177
// module chunks = 0